import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginPageComponent } from './login-page.component';
import { Globals } from '../../../globals';
import { LoginService } from '../login/login.service';
import { AuthenticationService } from '../services/authentication.service';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LucideIconsModule } from '../../../shared/lucide-icons.module';

@NgModule({
  declarations: [
    LoginPageComponent
  ],
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
    MatButtonModule, MatListModule, MatCardModule,
    MatDividerModule, MatIconModule,
        LucideIconsModule, MatSelectModule,
    MatInputModule, MatProgressSpinnerModule
  ],
  providers: [
    { provide: 'globals', useExisting: Globals },  // for library
    { provide: 'loginService', useExisting: LoginService },  // for library
    { provide: 'authService', useExisting: AuthenticationService },  // for library
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],/*
  exports: [
    LoginPageComponent
  ]*/
})
export class LoginPageModule { }
